<div class="header-container">
  <app-header></app-header>
</div>

<main class="min-h-screen bg-[#F2F3F5]">
  <div class="flex">
    <aside class="w-[20%] flex-shrink-0">
      <!-- Application Stepper -->
      <app-stepper [currentStep]="3"></app-stepper>
    </aside>
    <div class="w-full p-8 mx-5">
      <h1 class="text-2xl font-bold text-gray-800 mb-6">
        {{ "HEALTH_DECLARATION.TITLE" | translate }}
      </h1>
      <p class="text-gray-600 text-sm mb-6">
        {{ "HEALTH_DECLARATION.PAGE_DESC" | translate }}
      </p>

      <!-- Main Card Container -->
      <div class="bg-white rounded-lg shadow-sm overflow-hidden">
        <!-- Member Health Declarations Header -->
        <div class="bg-gray-50 px-6 py-4 border-b border-gray-200">
          <h2 class="text-lg font-semibold text-gray-800">
            {{ "HEALTH_DECLARATION.MEMBER_HEALTH_DECLARATIONS" | translate }}
          </h2>
        </div>

        <!-- Member Card -->
        <div class="p-6">
          <div *ngFor="let member of filteredMembers" class="mb-4 last:mb-0">
            <div
              class="flex items-center justify-between border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
            >
              <!-- Left Section: Member Info -->
              <div class="flex items-center space-x-4">
                <!-- Avatar -->
                <div
                  class="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center"
                >
                  <span class="text-teal-600 font-semibold text-lg">
                    {{ member.name.charAt(0) }}
                  </span>
                </div>

                <!-- Member Details -->
                <div>
                  <div class="flex items-center space-x-2">
                    <span class="font-semibold text-gray-800 text-base">
                      {{ member.name }} ({{ member.idNumber }})
                    </span>
                  </div>
                  <div class="flex items-center space-x-4 mt-1">
                    <span class="flex items-center text-sm text-gray-600">
                      <svg
                        class="w-4 h-4 mr-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      {{ member.dob }}
                    </span>
                    <span class="text-sm text-gray-600">{{ member.type }}</span>
                  </div>
                </div>
              </div>

              <!-- Right Section: Status and Action -->
              <div class="flex items-center space-x-4">
                <div class="text-right">
                  <div class="flex items-center justify-end space-x-2">
                    <span class="text-sm text-gray-600">{{
                      "HEALTH_DECLARATION.STATUS" | translate
                    }}</span>
                    <span
                      class="flex items-center text-green-600 font-medium text-sm"
                    >
                      <svg
                        class="w-5 h-5 mr-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      {{
                        "HEALTH_DECLARATION.DECLARATION_COMPLETE" | translate
                      }}
                    </span>
                  </div>
                </div>

                <button
                  class="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white text-sm font-medium rounded-md transition-colors"
                  (click)="openPopup(member)"
                >
                  {{ "HEALTH_DECLARATION.UPDATE_DECLARATION" | translate }}
                </button>
              </div>
            </div>
          </div>

          <!-- No Members Message -->
          <div *ngIf="filteredMembers.length === 0" class="text-center py-12">
            <svg
              class="w-16 h-16 mx-auto text-gray-300 mb-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            <p class="text-gray-500">
              {{ "HEALTH_DECLARATION.NO_MEMBERS_FOUND" | translate }}
            </p>
          </div>
        </div>

        <!-- Declaration and Terms Section -->
        <div class="bg-teal-50 mx-6 mb-6 rounded-lg border-2 border-teal-100">
          <div class="p-6">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">
              {{ "HEALTH_DECLARATION.DECLARATION_AND_TERMS" | translate }}
            </h3>

            <p class="text-sm text-gray-700 mb-3">
              {{ "HEALTH_DECLARATION.BY_PROCEEDING_DECLARE" | translate }}
            </p>

            <ol
              class="list-decimal list-inside space-y-2 text-sm text-gray-700 mb-6"
            >
              <li>{{ "HEALTH_DECLARATION.DECLARATION_ITEM_1" | translate }}</li>
              <li>
                {{ "HEALTH_DECLARATION.DECLARATION_ITEM_2" | translate }}
              </li>
              <li>{{ "HEALTH_DECLARATION.DECLARATION_ITEM_3" | translate }}</li>
            </ol>

            <label class="flex items-center cursor-pointer">
              <input
                type="checkbox"
                class="h-5 w-5 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                [(ngModel)]="termsAccepted"
              />
              <span class="ml-3 text-sm font-medium text-gray-900">
                {{ "HEALTH_DECLARATION.ACCEPT_TERMS" | translate }}
              </span>
            </label>
          </div>
        </div>
      </div>

      <!-- Navigation Buttons -->
      <div class="flex items-center justify-between mt-6">
        <button
          type="button"
          class="flex items-center px-6 py-2.5 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors font-medium"
          (click)="onBack()"
        >
          <svg
            class="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
          {{ "HEALTH_DECLARATION.BACK_TO_ADD_MEMBERS" | translate }}
        </button>

        <button
          type="button"
          [disabled]="!termsAccepted"
          [class.opacity-50]="!termsAccepted"
          [class.cursor-not-allowed]="!termsAccepted"
          class="flex items-center px-6 py-2.5 bg-teal-600 hover:bg-teal-700 disabled:hover:bg-teal-600 text-white rounded-md transition-colors font-medium"
          (click)="onContinue()"
        >
          {{ "HEALTH_DECLARATION.CONTINUE_TO_SELECT_QUOTE" | translate }}
          <svg
            class="w-5 h-5 ml-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</main>

<!-- Popup Modal -->
<div
  *ngIf="showPopup"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
>
  <app-health-declaration-popup
    [member]="selectedMember"
    (close)="closePopup()"
    (save)="onSaveDeclaration($event)"
  >
  </app-health-declaration-popup>
</div>

<app-footer layout="slim"></app-footer>
